<template>
    <div class="setting-content--section">
        <b-form @submit="onSubmit">
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Logo')" label-for="input-1">
                <VueDropzone :preloaded_file="imageSrc" :upload_url="Urls['company_profile_detail'](form.id)" image_field_name="logo" :delete_url="Urls['company_profile_delete_logo'](form.id)"></VueDropzone>
            </b-form-group>
            <b-form-group id="input-group-1" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Email')" label-for="input-1" :description="$gettext('Invoices will be sent from this e-mail address.')">
                <b-form-input id="input-1" v-model="form.email" :placeholder="$gettext('john.doe@email.com')" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-2" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-2" class="checkbox-bg-color" v-model="form.companysettings.include_sender_in_cc" @change="onFormChange" switch><span v-translate>Send me a copy of each sent invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-3" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-3" class="checkbox-bg-color" v-model="form.companysettings.attach_ubl_to_invoice" @change="onFormChange" switch><span v-translate>Attach a UBL invoice to every sent invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-4" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default VAT')" label-for="input-4">
                <b-input-group append="%" class="width50">
                    <b-form-input id="input-4" type="number" v-model="form.default_tax_rate" placeholder="0.0" @change="onFormChange" :disabled="defaultVatDisabled"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group id="input-group-5" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-5" class="checkbox-bg-color" v-model="form.default_tax_rate_exempt" :disabled="vatExemptDisabled" @change="onFormChange" switch><span v-translate>VAT exempt</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-6" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-6" class="checkbox-bg-color" v-model="form.default_tax_rate_reversed" :disabled="vatReversedChargeDisabled" @change="onFormChange" switch><span v-translate>VAT reversed charge</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-7" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Invoice Inc./Ex. VAT')" label-for="input-7">
                <template v-slot:description>
                    <p id="hint_id_default_invoice_inc_vat" class="help-block"><span v-translate>Show the invoice lines including or excluding VAT. <br>Ex. VAT is normal when invoicing businesses. <br>Inc. VAT can be used when selling to consumers.</span></p>
                </template>
                <b-form-select id="input-7" v-model="form.companysettings.default_invoice_inc_vat" :options="incExVat" @change="onFormChange" required></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-8" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default payment term*')" label-for="input-8">
                <b-input-group :append="$gettext('days')" class="width50">
                    <b-form-input id="input-8" type="number" v-model="form.default_payment_term" placeholder="30" @change="onFormChange"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group id="input-group-9" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default invoice message')" label-for="input-9" :description="$gettext('This is the default message at the bottom of each invoice.')">
                <b-form-textarea id="input-9" v-model="form.default_invoice_message" :placeholder="$gettext('Please complete payment for this invoice within 30 days from the date on this invoice.')" rows="3" @change="onFormChange"></b-form-textarea>
            </b-form-group>
            <b-form-group id="input-group-9" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default invoice email message')" label-for="input-9" :description="$gettext('This is the default email message when sending an invoice.')">
                <b-form-textarea id="input-9" v-model="form.companysettings.default_invoice_email_message" :placeholder="$gettext('Dear john, please find my invoice attached to this email. Have a nice day!')" rows="3" @change="onFormChange"></b-form-textarea>
            </b-form-group>

            <legend v-translate>Your company details</legend><hr>
            <b-form-group id="input-group-10" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Address')" label-for="input-10">
                <b-form-input id="input-10" v-model="form.address" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-11" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Postal Code')" label-for="input-11">
                <b-form-input id="input-11" v-model="form.postal_code" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-12" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('City')" label-for="input-12">
                <b-form-input id="input-12" v-model="form.city" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-13" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Country')+'*'" label-for="input-13">
                <b-form-select id="input-13" v-model="form.country" :options="countries" disabled @change="onFormChange"></b-form-select>
            </b-form-group>
            <b-form-group id="input-group-14" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-14" class="checkbox-bg-color" v-model="form.show_country_on_invoice" @change="onFormChange" switch><span v-translate>Show country on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-15" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Bank name')+'*'" label-for="input-15">
                <b-form-input id="input-15" v-model="form.bank_name" required @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-16" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Bank account number')+'*'" label-for="input-16">
                <b-form-input id="input-16" v-model="form.bank_account_number" required @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-17" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('BIC/Swift')" label-for="input-17">
                <b-form-input id="input-17" v-model="form.companysettings.swift_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-18" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-18" class="checkbox-bg-color" v-model="form.companysettings.show_swift_on_invoice" @change="onFormChange" switch><span v-translate>Show BIC/Swift on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-19" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('VAT identification number')" label-for="input-19">
                <b-form-input id="input-19" v-model="form.btw" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-20" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('KvK number')" label-for="input-20" :description="$gettext('Chamber of Commerce registration number.')">
                <b-form-input id="input-20" v-model="form.kvk" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-21" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-21" class="checkbox-bg-color" v-model="form.btw_show_on_invoice" @change="onFormChange" switch><span v-translate>Show VAT identification number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-22" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Phone number')" label-for="input-22">
                <b-form-input id="input-22" v-model="form.phone_number" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-23" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-23" class="checkbox-bg-color" v-model="form.phone_number_show_on_invoice" @change="onFormChange" switch><span v-translate>Show phone number on invoice</span></b-form-checkbox>
            </b-form-group>
            <b-form-group id="input-group-24" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Website')" label-for="input-24">
                <b-form-input id="input-24" v-model="form.website" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-25" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <b-form-checkbox id="input-25" class="checkbox-bg-color" v-model="form.website_show_on_invoice" @change="onFormChange" switch><span v-translate>Show website on invoice</span></b-form-checkbox>
            </b-form-group>

            <!--<legend v-translate>Payments</legend><hr>
            <b-form-group id="input-group-26" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('bunq.me/')" label-for="input-26">
                <template v-slot:description v-translate>
                    <p id="hint_id_bunq_me_url" class="help-block">This is your personal bunq.me link. It can be used by other people to quickly transfer money to you. Click <a href="https://bunq.me/" target="_blank">here</a> to be redirected to bunq.me to generate your personal link.</p>
                </template>
                <b-form-input id="input-26" v-model="form.companysettings.bunq_me_url" @change="onFormChange"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-27" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin">
                <template v-slot:description v-translate>
                    <p id="hint_id_include_bunq_url" class="help-block">By default add a button in the email to directly pay invoices when sending using the bunq.me personal link</p>
                </template>
                <b-form-checkbox id="input-27" class="checkbox-bg-color" v-model="form.companysettings.include_bunq_url" @change="onFormChange" switch><span v-translate>Include link to pay invoices using Bunq</span></b-form-checkbox>
            </b-form-group>-->

            <legend v-translate>Importing hours</legend><hr>
            <b-form-group id="input-group-28" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default hourly rate (Ex. VAT)')" label-for="input-28" :description="$gettext('The default rate we use when creating an invoice from your hours.')">
                <b-input-group pre="€" class="width50">
                    <b-form-input id="input-28" type="number" v-model="form.hourly_rate" step="0.01" placeholder="30" @change="onFormChange"></b-form-input>
                </b-input-group>
            </b-form-group>
            <b-form-group id="input-group-29" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Invoice Inc./Ex. VAT')" label-for="input-29" :description="$gettext('When copying hours to a new invoice we convert from time (1 hour 30 minutes) to a quantity (1,5 hours). This setting allows you to choose your preferred precision.')">
                <b-form-select id="input-29" v-model="form.hours_rounding_precision" :options="hourRoundingPrecisionList" @change="onFormChange" required></b-form-select>
            </b-form-group>

            <legend v-translate>Importing trips</legend><hr>
            <b-form-group id="input-group-30" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" :label="$gettext('Default km compensation (Ex. VAT)')" label-for="input-30">
                <b-input-group pre="€" class="width50">
                    <b-form-input id="input-30" type="number" v-model="form.default_km_rate" step="0.01" placeholder="30" @change="onFormChange"></b-form-input>
                </b-input-group>
            </b-form-group>

            <b-alert class="float-alert-top" :show="showDismissibleCountdown" variant="success" dismissible @dismissed="showDismissibleCountdown=0" v-translate>
              Settings successfully updated!
            </b-alert>
            <b-form-group id="input-group-31" label-cols-sm="3" label-align-sm="right" content-cols-md="5" label-class="gk-label-margin" label="" label-for="input-31">
                <GekkoButton 
                    :text="$gettext('Save Settings')" 
                    icon="fa-solid fa-floppy-disk"
                    type="submit"
                />
            </b-form-group>

        </b-form>
    </div>
</template>

<script>
import CompanyService from "@/store/services/company.service.js";
import CompanySettingService from "@/store/services/companysetting.service.js";
import VueDropzone from "@/components/VueDropzone";
import GekkoButton from "@/components/GekkoButton";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "InvoiceSettings",
    components: {
        VueDropzone, GekkoButton
    },
    mixins: [settingsPageSetup],
    data() {
        return {
            showDismissibleCountdown: 0,
            pageSettings: {
                title: this.$gettext("Invoice settings"),
                showCompanyPicker: true
            },
            formChanged: false,
            form: {
                id: '',
                name: '',
                logo: null,
                email: '',
                default_tax_rate: '',
                default_tax_rate_exempt: '',
                default_tax_rate_reversed: '',
                default_payment_term: '',
                default_invoice_message: '',

                address: '',
                postal_code: '',
                city: '',
                country: 'NL',
                show_country_on_invoice: '',
                bank_name: '',
                bank_account_number: '',
                btw: '',
                kvk: '',
                btw_show_on_invoice: false,
                phone_number: '',
                phone_number_show_on_invoice: false,
                website: '',
                website_show_on_invoice: false,

                hourly_rate: 0,
                hours_rounding_precision: 0,
                default_km_rate: 0,
                companysettings: {
                    id: '',
                    company: '',
                    include_sender_in_cc: false,
                    attach_ubl_to_invoice: false,
                    default_invoice_inc_vat: false,
                    default_invoice_retention: 0,
                    default_invoice_email_message: '',

                    swift_number: '',
                    show_swift_on_invoice: '',

                    bunq_me_url: '',
                    include_bunq_url: false,
                }
            },
            incExVat:[{value: true, text:this.$gettext('Inc. VAT')},{value: false, text:this.$gettext('Ex. VAT')}],
            hourRoundingPrecisionList: [{value: 0, text:this.$gettext('Zero decimals (e.g. 1 hour)')},{value: 1, text:this.$gettext('One decimal (e.g. 1,2 hours)')},{value: 2, text:this.$gettext('Two decimals (e.g. 1,25 hours)')}],
            countries: [],
            imageSrc: '',
        }
    },
    created(){
        var vm = this;
        CompanyService.getCurrent().then(function(response){
            var data = response.data;
            vm.form = {
                id: data['id'],
                name: data['name'],
                logo: data['logo'],
                email: data['email'],
                default_tax_rate: data['default_tax_rate'],
                default_tax_rate_exempt: data['default_tax_rate_exempt'],
                default_tax_rate_reversed: data['default_tax_rate_reversed'],
                default_payment_term: data['default_payment_term'],
                default_invoice_message: data['default_invoice_message'],

                address: data['address'],
                postal_code: data['postal_code'],
                city: data['city'],
                country: data['country'],
                show_country_on_invoice: data['show_country_on_invoice'],
                bank_name: data['bank_name'],
                bank_account_number: data['bank_account_number'],
                btw: data['btw'],
                kvk: data['kvk'],
                btw_show_on_invoice: data['btw_show_on_invoice'],
                phone_number: data['phone_number'],
                phone_number_show_on_invoice: data['phone_number_show_on_invoice'],
                website: data['website'],
                website_show_on_invoice: data['website_show_on_invoice'],


                hourly_rate: data['hourly_rate'],
                hours_rounding_precision: data['hours_rounding_precision'],
                default_km_rate: data['default_km_rate'],
                companysettings: {
                    id: data.companysettings['id'],
                    company: data.companysettings['company'],
                    include_sender_in_cc: data.companysettings['include_sender_in_cc'],
                    attach_ubl_to_invoice: data.companysettings['attach_ubl_to_invoice'],
                    default_invoice_inc_vat: data.companysettings['default_invoice_inc_vat'],
                    default_invoice_retention: data.companysettings['default_invoice_retention'],
                    default_invoice_email_message: data.companysettings['default_invoice_email_message'],

                    swift_number: data.companysettings['swift_number'],
                    show_swift_on_invoice: data.companysettings['show_swift_on_invoice'],

                    bunq_me_url: data.companysettings['bunq_me_url'],
                    include_bunq_url: data.companysettings['include_bunq_url'],
                }
            };
            if(response.data.logo){
                vm.imageSrc = response.data.logo;
            }
            vm.form.logo = null;
        });
        CompanyService.getCountries().then(function(response){
            vm.countries = response.data;
        });
    },
    methods: {
        onSubmit(evt) {
            let vm = this;
            evt.preventDefault();
            //create or edit
            if(this.form.logo === null){
                delete(this.form.logo);
            }
            if(this.form.id){
                CompanyService.update(this.form).then(function(){
                    vm.showDismissibleCountdown = 2;
                    vm.formChanged = false;
                });
                CompanySettingService.update(this.form.companysettings);
            }
        },
        onFormChange(){
            this.formChanged = true;
        }
    },
    beforeRouteLeave (to, from , next) {
      var answer = true;
      if(this.formChanged){
        answer = window.confirm(this.$gettext('You made changes that have not yet been saved. Are you sure you want to continue and discard those changes?'))
      }
      if (answer) {
        next()
      } else {
        next(false)
      }
    },
    computed: {
        vatExemptDisabled(){
            return this.form.default_tax_rate_reversed;
        },
        vatReversedChargeDisabled(){
            return this.form.default_tax_rate_exempt;
        },
        defaultVatDisabled(){
            return this.form.default_tax_rate_exempt || this.form.default_tax_rate_reversed;
        }
    }
};
</script>
<style >
.checkbox-bg-color .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #0575ff;
    background-color: #0575ff;
}
.width50 {
    max-width: 41.6666666667%% !important;
    width: 41.6666666667%%  !important;
}
.float-alert-top{
    position: fixed !important;
    top: 50px;
    right: 15%;
    z-index: 1000;
}
</style>
